module.exports = global.devConfig = {
    cdns: 'https://open.francebaseball.com/cdn/v5',
    cdn: 'https://open.francebaseball.com/cdn/v5',
    api: 'https://localhost:7171/api',
    internalApi: 'https://localhost:7171/api',
    social: {
        facebook:'https://facebook.com/FranceBaseball',
        instagram:'https://instagram.com/francebaseball',
        twitter:'https://twitter.com/francebaseball'
    }
};